export default "__VITE_ASSET__CdqYBySG__"